import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import { TextField } from 'components/inputs/TextField/TextField'
import { Modal } from 'components/layout/Modal/Modal'
import { EditChatSchema } from 'validations/EditChatSchema'

interface EditChatFormProps {
  title: string
  isLoading: boolean
  onSave: (title: string) => void
  onCancel: () => void
}

const EditChatForm = ({ title, isLoading, onSave, onCancel }: EditChatFormProps) => {
  const { t } = useTranslation()
  const formik = useFormik({
    initialValues: { title },
    validationSchema: EditChatSchema,
    onSubmit: (values) => {
      if (!isLoading && values.title.trim() !== title.trim()) onSave(values.title.trim())
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <Modal.Content>
        <TextField
          autoFocus
          fullWidth
          id='chat-title'
          name='title'
          label={t('aiChat.history.titleLabel')}
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={formik.touched.title}
          errorMessage={t(formik.errors.title || '')}
          disabled={isLoading}
        />
      </Modal.Content>
      <Modal.Actions
        onCancel={onCancel}
        onSave={formik.handleSubmit}
        isLoading={isLoading}
        isSaveDisabled={!formik.values.title.trim()
          || formik.values.title.trim() === title.trim()}
      />
    </form>
  )
}

export { EditChatForm }
